import FreelanceDesigners from 'marketing/components/FreelanceDesigners';

document.addEventListener('DOMContentLoaded', () => {
    new FreelanceDesigners();
});



// WEBPACK FOOTER //
// ./js/marketing/logo-design-freelancer.js